import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box } from 'reflexbox';

import { useAuthenticatedUser, useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { FlexGap, Heading3, Join, Paragraph, PlainCard, Skeleton, tokens } from '@treams/treams-ui';

import ConversationParty from './ConversationParty';

export default Skeleton(
	function ConversationCard(props: {
		submission: graphql.EvaluationSubmission;
		showsOwner?: boolean;
	}) {
		const { localize } = useLocalize();
		const { t } = useTranslation();
		const viewer = useAuthenticatedUser();

		return (
			<PlainCard
				to={
					viewer.id === props.submission.employee.user.id
						? `/conversations/${props.submission.id}`
						: `/users/${props.submission.employee.user.id}/conversations/${props.submission.id}`
				}
			>
				<FlexGap flexDirection="column" alignItems="flex-start" gap={tokens.gap.list}>
					<Box>
						<Heading3>{localize(props.submission.evaluationForm.title).text}</Heading3>
						<Paragraph mt="4px">
							<Join separator=" · ">
								{props.showsOwner && (
									<>
										{t('conversations.outgoing.card.about')}{' '}
										<Link to={`/users/${props.submission.employee.user.id}`}>
											{props.submission.employee.user.firstName}{' '}
											{props.submission.employee.user.lastName}
										</Link>
									</>
								)}
								{t('conversations.incoming.card.createdAt', {
									date: moment(props.submission.createdAt).format('LL'),
								})}
								{t('conversations.incoming.card.dueDateWithTime', {
									date: moment(props.submission.deadline).format('LL'),
									time: moment(props.submission.deadline).format('HH:MM'),
								})}
							</Join>
						</Paragraph>
					</Box>
					<FlexGap flexDirection={['column', 'column', 'row']} gap={tokens.gap.list} width="100%">
						<ConversationParty
							result={props.submission.employee as graphql.EvaluationSubmissionResult}
						/>
						<ConversationParty
							result={props.submission.manager as graphql.EvaluationSubmissionResult}
						/>
					</FlexGap>
				</FlexGap>
			</PlainCard>
		);
	},
	function ConversationCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Box>
					<Heading3.Skeleton />
					<Paragraph.Skeleton mt="4px" lines={1} />
				</Box>
			</PlainCard.Skeleton>
		);
	},
);
